/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { ICompanyGroupPageOwnProps, ICompanyGroupPageStateProps, ICompanyGroupPageDispatchProps, CompanyGroupPage } from "../../components/companyGroup/CompanyGroupPage";
import { ITypedOption } from "../../models/common/typedOption";
import { CompanyGroupThunkDispatch, getCompanyGroupsPage } from "source/models/store/companyGroup";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ICompanyGroupPageOwnProps): ICompanyGroupPageStateProps {
    if (!applicationState || !applicationState.companyGroup) {
        return {
            appState: null,
            dataId: -1,
            companyGroupPage: null
        };
    }
    const companyGroup = applicationState.companyGroup;
    return {
        appState: applicationState.session,
        dataId: companyGroup.page.dataId,
        companyGroupPage: companyGroup.page.companyGroupPage
    };
}

export function mapDispatchToProps(dispatch: CompanyGroupThunkDispatch): ICompanyGroupPageDispatchProps {
    return {
        onGetCompanyGroupsPage: () => dispatch(getCompanyGroupsPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<ICompanyGroupPageStateProps, ICompanyGroupPageDispatchProps, ICompanyGroupPageOwnProps>(mapStateToProps, mapDispatchToProps)(CompanyGroupPage);